<template>
  <div style="background-color: white !important">
    <div>
      <div style="display: flex; justify-content: center; margin: 10px 0px">
        <v-form>
          <v-card
            rounded="2"
            class="p-2 login-form"
            style="max-width:550px; box-shadow: none; overflow: unset"
          >
            <div class="row">
              <div class="col-6 measureBox">
                <div>
                  <VLabel>FROM</VLabel>

                  <VAutocomplete
                    v-model="selectedFromcountry"
                    :items="filteredCountryNames"
                    required
                    placeholder="Select country"
                    :rules="overallFormValidation"
                    variant="underlined"
                    class="d-flex flex-column"
                  />
                </div>

                <div class="row">
                  <VRadioGroup
                    v-model="selectedDeliveryQuote"
                    inline
                    class="radio_btn"
                  >
                    <div class="col-6" style="height: 20px">
                      <VRadio label="PICKUP" value="PICKUP" />
                    </div>
                    <div class="col-6" style="height: 20px">
                      <VRadio label="HUB" value="HUB" />
                    </div>
                  </VRadioGroup>
                  <!-- <v-radio-group inline>
                  <v-radio label="Radio One" value="one"></v-radio>
                  <v-radio label="Radio Two" value="two"></v-radio>
                  <v-radio label="Radio Three" value="three"></v-radio>
                </v-radio-group> -->
                </div>
              </div>

              <div class="col-6 measureBox">
                <div style="position: relative;">
                  <label class="v-label">POSTALCODE/LOCATION</label>
                  <v-text-field
                    v-model="fromPostalcode"
                     variant="underlined"
                    :rules="overallFormValidation"
                    required
                    class="login-form postal-form"
                    @click="fromPostalUl = true,
                    this.fromPostalcode = null
                    "
                  >
                    
                  </v-text-field>


                  <div v-if="postalFrom" style="position: absolute;
    right: 15px;
    top: 30px;">
                     <v-progress-circular
      color="primary"
      :size="15"
      :width="2"
      indeterminate
    ></v-progress-circular>
                  </div>
                 
                </div>

                <ul
                  v-if="fromPostalcodeList.length > 0 && fromPostalUl"
                  class="dropdowdata"
                >
                  <li
                    v-for="postalCode in fromPostalcodeList"
                    :key="postalCode"
                    @click="
                      selectedFromPostal(
                        postalCode.zipcode,
                        postalCode.cityname
                      )
                    "
                    style="font-size: 13px; font-weight: 500;margin: 3px;"
                  >
                    {{ postalCode.zipcode }}-{{ postalCode.cityname }}
                  </li>
                </ul>

                <div class="row">
                  <VRadioGroup
                    v-model="DeliveryResiQuote"
                    inline
                    class="radio_btn"
                  >
                    <div class="col-6" style="height: 20px">
                      <VRadio label="RESIDENTIAL" value="RESIDENTIAL" />
                    </div>
                    <div class="col-6" style="height: 20px">
                      <VRadio label="COMMERCIAL" value="COMMERCIAL" />
                    </div>
                  </VRadioGroup>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-6 measureBox">
                <div>
                  <VLabel>TO</VLabel>
                  <VAutocomplete
                    class="login-form"
                    v-model="selectedTocountry"
                    :items="filteredCountryNames"
                    variant="underlined"
                    :rules="overallFormValidation"
                    placeholder="Select country"
                    required
                  />
                  <template>
                    <VProgressCircular
                      color="primary"
                      v-if="aerch2"
                      indeterminate
                    />
                  </template>
                </div>

                <div class="row">
                  <VRadioGroup
                    v-model="selectedDeliveryQuote1"
                    inline
                    class="radio_btn"
                  >
                    <div class="col-6">
                      <VRadio label="DELIVERY" value="DELIVERY1" />
                    </div>
                    <div class="col-6">
                      <VRadio label="HUB" value="HUB1" />
                    </div>
                  </VRadioGroup>
                </div>
              </div>

              <div class="col-6 measureBox">
                <div style="position: relative;">
                  <label class="v-label">POSTALCODE/LOCATION</label>
                  <v-text-field
                    v-model="toPostalcode"
                    variant="underlined"
                    :rules="overallFormValidation"
                    required
                    class="login-form postal-form"
                    @click="toPostalUl = true,  
                      this.toPostalcode  = null"
                  >
                    <template>
                      <VProgressCircular
                        color="primary"
                        v-if="aerch1"
                        indeterminate
                      />
                    </template>
                  </v-text-field>

                   <div v-if="postalTo" style="position: absolute;
    right: 15px;
    top: 30px;">
                     <v-progress-circular
      color="primary"
      :size="15"
      :width="2"
      indeterminate
    ></v-progress-circular>
                  </div>
                 
                </div>

                <ul
                  v-if="toPostalcodeList.length > 0 && toPostalUl"
                  class="dropdowdata"
                >
                  <li
                    v-for="postcode in toPostalcodeList"
                    :key="postcode"
                    @click="
                      selectedToPostal(postcode.zipcode, postcode.cityname)
                    "
                    style="font-size: 13px; font-weight: 500;margin: 3px;"
                  >
                    {{ postcode.zipcode }}-{{ postcode.cityname }}
                  </li>
                </ul>

                <div class="row">
                  <VRadioGroup
                    v-model="DeliveryResiQuote1"
                    inline
                    class="radio_btn"
                  >
                    <div class="col-6">
                      <VRadio label="RESIDENTIAL" value="RESIDENTIAL1" />
                    </div>
                    <div class="col-6">
                      <VRadio label="COMMERCIAL" value="COMMERCIAL1" />
                    </div>
                  </VRadioGroup>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-5 measureBox">
                <label class="v-label">SHIP DATE</label>

                <VueDatePicker
                  v-model="shipdateQuote"
                  :min-date="new Date()"
                  auto-apply
                  placeholder="Select Date"
                  :on-click-outside="ClickOutDepat"
                  :month-change-on-scroll="false"
                  :enable-time-picker="false"
                  :format="dateFormat"
                >
                </VueDatePicker>
              </div>
              <div class="col-4 measureBox">
                <label class="v-label">ITEM TYPE</label>
                <v-select
                  class="login-form itemType"
                  v-model="selectedItemQuote"
                  :items="['PARCEL/CARTON/BAGGAGE', 'PALLET', 'DOCUMENTS']"
                  required
                  variant="outlined"
                />
              </div>
              <div class="col-3 unitBox1">
                <label class="v-label">CURRENCY</label>
                <v-select
                  class="login-form itemType"
                  v-model="selectedCurrency"
                  :items="['AED','INR','LKR','AUD','CAD','USD']"
                  required
                  variant="outlined"
                />
              </div>
            </div>

            <!--  -->
            <div class="mt-1">
              <div v-for="(item, index) in allItemsQuote" :key="index">
                <div class="row gx-1">
                  <div class="col-3 unitBox2">
                    <label class="v-label">CURRENCY</label>
                    <v-select
                      class="login-form itemType"
                      v-model="selectedCurrency"
                      :items="['AED','INR','LKR','AUD','CAD','USD']"
                      required
                      variant="outlined"
                    />
                  </div>
                  <div class="col-2 unitBox">
                    <label class="v-label">UNIT</label>
                    <v-select
                      class="login-form1"
                      v-model="selectedUnitQuote"
                      variant="outlined"
                      :items="['KG', 'LB']"
                    />
                  </div>
                  <div class="col-2 unitBox">
                    <label class="v-label" style="font-weight: 700 !important;
    font-size: 11px !important;">WEIGHT</label>
                    <input
                      v-model="item.weightQuote"
                      @keypress="filter(event)"
                      class="input-form"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      placeholder=""
                      variant="outlined"
                    />
                  </div>

                  <div class="col-1 unitBox">
                    <label class="v-label" style="font-weight: 700 !important;
    font-size: 11px !important;">{{ `L (${measurement})` }}</label>
                    <input
                      v-model="item.lengthQuote"
                      @keypress="filter(event)"
                      class="input-form"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      placeholder=""
                      variant="outlined"
                    />
                  </div>
                  <div class="col-1 unitBox">
                    <label class="v-label" style="font-weight: 700 !important;
    font-size: 11px !important;">{{ `W (${measurement})` }}</label>
                    <input
                      v-model="item.widthQuote"
                      @keypress="filter(event)"
                      class="input-form"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      placeholder=""
                      variant="outlined"
                    />
                  </div>
                  <div class="col-1 unitBox">
                    <label class="v-label" style="font-weight: 700 !important;
    font-size: 11px !important;">{{ `H (${measurement})` }}</label>
                    <input
                      v-model="item.heightQuote"
                      @keypress="filter(event)"
                      class="input-form"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      placeholder=""
                      variant="outlined"
                    />
                  </div>

                  <div class="col-2 unitBox3">
                    <label class="v-label">QUANTITY</label>
                    <!-- <input
                      v-model="item.quantityQuote"
                      variant="outlined"
                      class="input-form"
                      @keypress="filter(event)"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      placeholder=""
                    /> -->
                     <v-select
                          v-model="item.quantityQuote"
                          variant="outlined"
                          class="login-form"
                          :items="[
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9','10','11','12','13','14','15'
                          ]"
                        />

                  </div>
                  <div class="col-3 unitBox4">
                    <div :class="index > 0 ? 'd-flex' : ''">
                      <div :style="'width:' + (index !== 0 ? '85%' : '')">
                        <label class="v-label"
                          >PACKAGE-TYPE {{ index + 1 }}</label
                        >
                        <v-select
                          v-model="item.selectedPackageQuote"
                          variant="outlined"
                          class="login-form"
                          :items="[
                            'BOX',
                            'PALLET',
                            'ENVELOPE',
                            'SATCHEL',
                            'ROLL',
                            'DRUM',
                            'CRATE',
                            'BAG',
                            'CARTON',
                          ]"
                        />
                      </div>
                      <div style="display: flex; align-items: center">
                        <div @click="removeItemQuote(index)" v-if="index > 0">
                          <v-icon color="red">mdi-close-circle-outline</v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row mt-2 justify-content-between"
              style="position: relative"
            >
              <div class="col-3 mb-sm-0 mb-2 btnBox">
                <v-btn
                  block
                  color="primary"
                  class="but-color"
                  @click="addItemQuote"
                  >ADD ITEM</v-btn
                >
              </div>
              <div class="col-3 btnBox">
                <VBtn
                  block
                  class="but-color"
                  target="_blank"
                  :disabled="!getQuoteValidation"
                  @click="getQuote()"
                  style="background: #ed1c24 !important"
                >
                  GET QUOTE
                </VBtn>
              </div>
              <!-- <a target="_blank" href="http:google.com"> test </a> -->
            </div>
          </v-card>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import countryList from "@/countries.json";
import axios from "axios";
import moment from "moment";
import VueDatePicker from "@vuepic/vue-datepicker";

export default {
  props: {
    formData: {
      type: Array,
      required: true
    }
  },
  components: {
    VueDatePicker,
  },
  data() {
    return {
      routerchange:false,
      strResult: "123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      valied: false,
      dateFormat: "dd MMM, yyyy",
      formedData:[],
      allItemsQuote: [
        {
          selectedPackageQuote: "Box",
          weightQuote: "",
          quantityQuote: "",
          heightQuote: "",
          widthQuote: "",
          lengthQuote: "",
        },
      ],
      endpoint:"",
      fromPostalUl: false,
      aerch1: false,
      aerch2: false,
      toPostalUl: false,
      selectedUnitQuote: "KG",
      loader1: false,

      measurement: "cm",

      username: "",

      useremail: "",

      contactNum: "",

      selectedFromcountry: "",

      selectedTocountry: "",

      selectedItemQuote: "PARCEL/CARTON/BAGGAGE",

      PickupResiQuote: "COMMERCIAL",
      DeliveryResiQuote: "COMMERCIAL",
      DeliveryResiQuote1: "COMMERCIAL1",
      selectedPickupQuote: "PICKUP",
      selectedDeliveryQuote: "PICKUP",
      selectedDeliveryQuote1: "DELIVERY1",
      selectedPickupQuote1: "PICKUP1",
      fromPostalcode: "",
      fromPostalcodeList: [],
dupFromData:[],
dupToData:[],
      toPostalcode: "",
      toPostalcodeList: [],

      shipdateQuote: "",

      selectedCurrency: "AED",

      countryListarray: [],

      fromcountryCode: [],

      tocountryCode: [],

      staticresponse: [],

      splittedFrom: "",

      splittedTo: "",

      getQuoteId: "",

      getquoteloader: false,

      postalUAEfrom: "",

      postalUAEto: "",

      carrierlogoUrlPrefix: "https://cdn.wistirna.com/resources/apps/courier/",

      lastrowValidation: [
        (v) => !!v || "Please enter a valid input",
        (v) => /^[0-9]*$/.test(v) || "Only numeric values are allowed",
      ],
      overallFormValidation: [(v) => !!v || "Please enter a valid input"],
      emailRequire: [
        // (v) => !!"Please enter a valid input",
        (v) => /.+@.+\..+/.test(v) || "Please enter a valid email address",

        // v => /^[a-z.-]+@[a-z.-]+\.[a-z]+$/i || "Please enter a valid email address",
      ],
      contactRules: [
        (value) => {
          if (value?.length >= 5) return true;

          return "Enter a valid contact number.";
        },
        (v) => !!v || "Please enter a valid input",
        (v) => /^[0-9+ -]*$/.test(v) || "Only numeric values are allowed",
      ],

      // overlay data

      openOverlay: false,
      postalFrom:false,
      postalTo:false,
      overlayStep1: true,
      overlayStep2: false,
      overlayStep3: false,
      booking_refId: "",
      fromCity: "",
      toCity: "",
      nameSender: "",
      nameReceiver: "",
      emailSender: "",
      emailReceiver: "",
      companySender: "",
      companyReceiver: "",
      mobileSender: "",
      mobileReceiver: "",
      address1Sender: "",
      address1Receiver: "",
      address2Sender: "",
      address2Receiver: "",
      address3Sender: "",
      address3Receiver: "",
      citySender: "",
      cityReceiver: "",
      zipcodeSender: "",
      zipcodeReceiver: "",
      contentDescription: "",
      pickupdate: "",
  fromPostalnew:"",
  toPostalnew:"",
      selectedResponseId: "",
      selectedResponse: "",
    };
  },

  computed: {
    filteredCountryNames() {
      console.log(countryList,'countryList')
      countryList.forEach((item) => {
        return this.countryListarray.push({
          code: item.code,
          country: item.name,
        });
      });

      return countryList.map((country) => country.name);
    },

    getQuoteValidation() {
      return (
        
        this.selectedFromcountry !== "" &&
        this.fromPostalcode !== "" &&
        this.selectedTocountry !== "" &&
        this.toPostalcode !== "" &&
        this.shipdateQuote !== "" &&
        this.allItemsQuote.every(
          (item) =>
            item.weightQuote !== "" &&
            item.lengthQuote !== "" &&
            item.heightQuote !== "" &&
            item.widthQuote !== "" &&
            item.quantityQuote !== ""
        )
      );
    },

    booknowValidation() {
      return (
        this.address1Sender !== "" &&
        this.address2Sender !== "" &&
        this.nameReceiver !== "" &&
        this.emailReceiver !== "" &&
        this.validateEmail(this.emailReceiver) &&
        this.mobileReceiver !== "" &&
        this.mobileReceiver.length >= 5 &&
        this.validateContact(this.mobileReceiver) &&
        this.address1Receiver !== "" &&
        this.address2Receiver !== "" &&
        this.contentDescription !== "" &&
        this.checkCompanySender(this.PickupResiQuote) &&
        this.checkCompanyReceiver(this.DeliveryResiQuote)
      );
    },
  },

  watch: {
    selectedFromcountry(newval) {
      console.log(newval, "newval");
      this.aerch1 = true;
      this.fromcountryCode = [];
      this.fromPostalcodeList = [];
        if (this.fromPostalnew) {
      this.fromPostalcode = this.fromPostalnew;
    } else {
      this.fromPostalcode = null;
    }
    this.fromPostalnew = null;
      this.countryListarray.filter((item) => {
        // console.log(item, "itemitem2222222 ");
        if (item.country === newval) {
          this.fromcountryCode.push(item);
        }
      });
      //   if (this.fromcountryCode.length > 0) {
      //     this.aerch1 = false;
      //   }
    },
    selectedTocountry(newval) {
      console.log(newval, "newval");
      this.aerch2 = true;

      this.tocountryCode = [];
      this.toPostalcodeList = [];


if (this.toPostalnew) {
      this.toPostalcode = this.toPostalnew;
    } else {
      this.toPostalcode = null;
    }
    this.toPostalnew = null;

      this.countryListarray.filter((item) => {
        // console.log(item, "itemitem2222222 ");
        if (item.country === newval) {
          this.tocountryCode.push(item);
        }
      });
      if (this.tocountryCode.length > 0) {
        this.aerch2 = false;
      }
    },

    async fromPostalcode(val) {
      console.log(val,'val')
      if( val && val.length == 3 ){
this.postalFrom= true
      }
      else if( val && val.length < 3 ){
this.postalFrom= false
      }
     
      
      this.fromPostalcodeList=[]
      if (val?.length >  2) {
        if (val.length > 2) {
         try {
         let getpostacode= 
         `https://www.dtdcaustralia.com.au/api/other_country_city_suggestion?&zip_code=${val}&country_code=${this.fromcountryCode[0].code}`
  const response = await axios.get(getpostacode);
  console.log(response,'response')
  this.postalFrom= false
  let data = response.data;
  if (data && Array.isArray(data.data)) {
  
    data = data.data;
  }
  if (Array.isArray(data) && data.length > 0) {
    this.fromPostalcodeList = data.map((items) => ({
      cityname: items.name,
      zipcode: items.zip_code,
    }));
     this.dupFromData=this.fromPostalcodeList
  }
  else{
  this.fromPostalcodeList= this.dupFromData
  }
} catch (error) {
  // console.error("API Error:", error.response?.data || error.message);
}

        }
      }
    },

   async toPostalcode(valto) {
       this.toPostalcodeList=[]
          if( valto && valto.length == 3 ){
this.postalTo= true
      }
      else if( valto && valto.length < 3 ){
this.postalTo= false
      }
      
      if (valto) {
        
        if (valto.length > 2) {
          try {
                   let getpostacode= 
         `https://www.dtdcaustralia.com.au/api/other_country_city_suggestion?zip_code=${valto}&country_code=${this.tocountryCode[0].code}`
  
  const response = await axios.get(getpostacode);

  let data = response.data;
this.postalTo= false
    if (data && Array.isArray(data.data)) {
      data = data.data;
    }

    if (Array.isArray(data) && data.length > 0) {
      this.toPostalcodeList = data.map((items) => ({
        cityname: items.name,
        zipcode: items.zip_code,
      }));
      this.dupToData= this.toPostalcodeList
    } else{
  this.toPostalcodeList= this.dupToData
  }
} catch (error) {
  // console.error("API Error:", error.response?.data || error.message);
}


        }
      }
    },
    // selectedFromcountry() {
    //   this.fromPostalcode = "";
    // },
    // selectedTocountry() {
    //   this.toPostalcode = "";
    // },
    selectedUnitQuote(val) {
      if (val == "KG") {
        this.measurement = "cm";
      } else if (val == "LB") {
        this.measurement = "in";
      }
    },
  },

  methods: {
    calculateTotalWeightAndQuantity() {
      this.totPackages = 0;
      this.totWeight = 0;
      this.allItemsQuote.filter((total) => {
        console.log(total, "totaltotal");
        this.totPackages =
          parseInt(this.totPackages) + parseInt(total.quantityQuote);
        this.totWeight =
          parseInt(this.totWeight) +
          parseInt(total.quantityQuote * total.weightQuote);
      });

      console.log(this.totPackages, this.weightQuote, "  this.totWeight ");
    },

    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateEmail(email) {
      return /.+@.+\..+/.test(email);
    },
    validateContact(contact) {
      return /^[0-9+ -]*$/.test(contact);
    },
    checkCompanySender(companysender) {
      if (
        (companysender == "COMMERCIAL" && this.companySender !== "") ||
        (companysender == "RESIDENTIAL" &&
          (this.companySender == "" || this.companySender !== ""))
      ) {
        return true;
      }
    },
    checkCompanyReceiver(companyreceiver) {
      if (
        (companyreceiver == "COMMERCIAL" && this.companyReceiver !== "") ||
        (companyreceiver == "RESIDENTIAL" &&
          (this.companyReceiver == "" || this.companyReceiver !== ""))
      ) {
        return true;
      }
    },
    momentfunc(date) {
      console.log(moment(date).format("YYYY-MMM-DD"), "momentvalue");

      return moment(date).format("YYYY-MMM-DD");
    },
    addItemQuote() {
      this.allItemsQuote.push({
        selectedPackageQuote: "",
        weightQuote: "",
        quantityQuote: "",
        heightQuote: "",
        widthQuote: "",
        lengthQuote: "",
      });
    },
    removeItemQuote(index) {
      this.allItemsQuote.splice(index, 1);
    },
    selectedFromPostal(data1, data2) {
      if (data1 == null) {
        data1 = "";
        this.fromPostalcode = `${data1}-${data2}`;
      } else {
        this.fromPostalcode = `${data1} - ${data2}`;
      }
      this.fromPostalUl = false;
      this.postalsplittedFrom = this.fromPostalcode.split("-");
      console.log(this.postalsplittedFrom, " this.postalsplittedFrom");
      this.fromCity =
        this.postalsplittedFrom[this.postalsplittedFrom.length - 1];
      this.countryPostalcontFrom = true;
    },
    selectedToPostal(data1, data2) {
      if (data1 == null) {
        data1 = "";
        this.toPostalcode = `${data1}-${data2}`;
      } else {
        this.toPostalcode = `${data1} - ${data2}`;
      }
      this.toPostalUl = false;
      this.postalsplittedTo = this.toPostalcode.split("-");
      this.toCity = this.postalsplittedTo[this.postalsplittedTo.length - 1];
      this.countryPostalcontTo = true;
    },
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = currentDate.getDate();
      day = day < 10 ? "0" + day : day;

      return `${year}-${month}-${day}`;
    },
    postalUAEfunc() {
      if (this.splittedFrom[0] === " " || this.splittedFrom[0] === null) {
        this.zipcodeSender = this.splittedFrom[1];

        return (this.postalUAEfrom = this.splittedFrom[1]);
      } else {
        this.zipcodeSender = this.splittedFrom[0];

        return (this.postalUAEfrom = this.splittedFrom[0]);
      }
    },
    postalUAEtofunc() {
      if (this.splittedTo[0] === "" || this.splittedTo[0] === null) {
        this.zipcodeReceiver = this.splittedTo[1];

        return (this.postalUAEto = this.splittedTo[1]);
      } else {
        this.zipcodeReceiver = this.splittedTo[0];

        return (this.postalUAEto = this.splittedTo[0]);
      }
    },
    async getQuote() {
      this.calculateTotalWeightAndQuantity();
      this.postalUAEfunc();
      this.postalUAEtofunc();
      this.loader1 = true;
      // sessionStorage.setItem('portalCurrency',this.selectedCurrency)
      console.log(this.totPackages, this.totWeight, "totWeight");
      let quotedata = {
        fromCountry: this.selectedFromcountry,
        fromPostal: this.fromPostalcode,
        fromcity: this.fromCity,
        toCountry: this.selectedTocountry,
        toPostal: this.toPostalcode,
        tocity: this.toCity,
        pickup: this.selectedPickupQuote,
        delivery: this.selectedDeliveryQuote,
        pickupresi: this.PickupResiQuote,
        deliveryresi: this.DeliveryResiQuote,
        shipDate: moment(this.shipdateQuote).format("YYYY-MM-DD"),
        itemtype: this.selectedItemQuote,
        currency: this.selectedCurrency,
        fromcountrycode: this.fromcountryCode[0].code,
        tocountrycode: this.tocountryCode[0].code,
        unit: this.selectedUnitQuote,
        quoteId: Math.ceil(Math.random() * 1000000),
        packageType: this.allItemsQuote[0].selectedPackageQuote,
        totalQuantity: this.totPackages,
        totalWeight: this.totWeight,
        items: this.allItemsQuote.map((item) => ({
          weight: item.weightQuote,
          length: item.lengthQuote,
          height: item.heightQuote,
          width: item.widthQuote,
          quantity: item.quantityQuote,
          packageType:item.selectedPackageQuote
        })),
      };

      let originalDate = new Date(this.shipdateQuote);
      let twodaysLater = new Date(originalDate);
      twodaysLater.setDate(originalDate.getDate() + 2);
      this.pickupdate = twodaysLater.toISOString().slice(0, 10);

      this.mobileSender = this.contactNum;
      this.nameSender = this.username;
      this.emailSender = this.useremail;

      this.getquoteloader = true;

      console.log(quotedata, "quotedata");
      try {
        const response = await axios.post(
          `https://xportal.skyrouteexpress.com/api/getquotecache`,
          quotedata,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response.data.quoteProcessId, "responseresponseresponse");

        if (response.data.quoteProcessId) {
 const quoteProcessId = response.data.quoteProcessId;


 if(this.routerchange){
   this.$router.push({
    path: "/formResponse",
    query: { quoteRequest_id: quoteProcessId }
  });
 
   setTimeout(()=>{
  this.$emit('updateQuote',true);
   },500)
  
   
 }
 else{
//  const routeData = this.$router.resolve({
//     path: "/formResponse",
//     query: { quoteRequest_id: quoteProcessId }
//   });

//   window.open(routeData.href, "_blank");
      // const vueUrl = `https://skyrouteexpbook.vercel.app/formResponse?quoteRequest_id=${quoteProcessId}`;

    if (response.data.quoteProcessId) {
  // const quoteProcessId = response.data.quoteProcessId;
  //   const wpUrl = `https://skyrouteexpress.com/quoterequest_id/`;
  //   window.open(wpUrl, "_blank");
  const quoteProcessId = response.data.quoteProcessId;
  const wpUrl = `https://skyrouteexpress.com/quoterequest_id/?getRequest_id=${quoteProcessId}`;
  window.open(wpUrl, "_blank");

  // await axios.post(
  //   "https://skyrouteexpress.com/wp-json/skyroute/v1/saveQuoteId",
  //   { quoteRequest_id: quoteProcessId },
  //   { headers: { "Content-Type": "application/json" } }
  // );
}
    }
       
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }

      console.log(quotedata, "quotedataquotedata");
    },

    getRandomChars(length) {
      let result = "";
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * this.strResult.length);
        result += this.strResult[randomIndex];
      }
      console.log(result, "result");
      return result;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    generateBookingRefId() {
      const randomChars1 = this.getRandomChars(3);
      const randomNum = this.getRandomInt(10, 99);
      const randomChars2 = this.getRandomChars(3);

      this.booking_refId = randomChars1 + randomNum + randomChars2;
      console.log(this.booking_refId, "this.booking_refId ");
    },
    async getIpAddress() {
  try {
    const response = await axios.get("https://ipwho.is/");
    console.log(response.data, "IP Data");

    this.ip = response.data.ip;
    this.selectedFromcountry = response.data.country;
    this.fromcountryCode[0].code = response.data.country_code;
  } catch (err) {
    console.error("IP fetch error:", err);
  }
},

assignFormvalue(formData){

  this.selectedFromcountry=formData.fromCountry
this.fromPostalnew=formData.fromPostal
this.selectedTocountry=formData.toCountry
this.toPostalnew=formData.toPostal
this.shipdateQuote=formData.shipDate
this.selectedItemQuote=formData.itemtype
this.selectedCurrency=formData.currency
this.fromCity=formData.fromcity
this.toCity=formData.tocity
 console.log(formData,formData.fromPostal,this.fromPostalcode,'formData')

this.allItemsQuote = formData.items.map(a => ({
  weightQuote: a.weight,
  quantityQuote: a.quantity,
  heightQuote: a.height,
  widthQuote: a.width,
  selectedPackageQuote: formData.packageType,
  lengthQuote: a.length
}))

 
       

 
},
    
  },
  created() {
      console.log(this.formedData,'this.formedData')
   this.formedData = this.formData
    if(this.formedData ?.fromCountry && this.formedData ?.toCountry ){
      console.log(this.formedData,'this.formedData1111')
    this.assignFormvalue(this.formedData)
    this.routerchange=true
    }
    else{
    this.endpoint=localStorage.getItem("endpoint")
    console.log(this.endpoint,'this.endpoint')
    this.generateBookingRefId();
      this.getIpAddress()
    }
  
  },
};
</script>

<style scoped>
.input{
    background: none !important;
}
.reqform_title {
  margin-block-start: -18px;
}

.v-selection-control-group {
  margin-block-start: -17px !important;
}

.requestform-card .v-input--density-compact {
  --v-input-control-height: 1.9375rem !important;
  --v-input-padding-top: -0.125rem;
}

.requestform-card .v-input {
  margin-block-end: -1rem !important;
}

>>> .v-field__input .v-select__selection-text {
  font-size: 14px !important;
  font-weight: 600 !important;
}
>>> .v-list-item-title {
  font-size: 11px !important;
  font-weight: 500 !important;
}
>>> .v-autocomplete .v-autocomplete__selection-text {
  font-size: 14px !important;
  font-weight: 600 !important;
}
>>> .v-field__input input {
  font-size: 14px !important;
  font-weight: 600 !important;
}
.removebtn {
  margin-block-start: 20px;
}

.package_row {
  margin-block-end: 8px;
}

.v-field__input {
  padding-block-end: 0 !important;
}

.v-btn .v-btn__content {
  font-weight: 650;
}

.card {
  padding: 47px;
}

.dropdowdata {
  position: absolute;
  z-index: 99;
  padding: 5;
  border-radius: 8px;
  margin: 0;
  background-color: white;
  box-shadow: inset 0 0 2px black;
  max-width: 100%;
  list-style: none;
  margin-block-start: 7px;
  overflow-y: scroll;
  height:250px;
      width: 250px;
  cursor: pointer;
}

.dropdowdatali {
  padding: 10px;
  cursor: pointer;
}

.dropdowdatali:hover {
  background-color: #f0f0f0;
}

.to_section {
  margin-block-start: -25px;
}

.overallcontainer {
  color: black !important;
  inline-size: 100%;

  /* margin-block: 6.20rem; */
}

.card2 {
  padding: 25px;
  border: 2px solid #ed1c24;
  color: black !important;
  inline-size: 100%;
  margin-block-end: 20px;
}

.card2 p {
  color: black !important;
}

.vertical-line {
  background-color: black;
  block-size: 150px;
  inline-size: 1px;
}

.quote_title {
  color: white;
  text-align: start;
}

.quotesoverall {
  padding: 30px;
  border-radius: 6px;
  background-color: #22224d;
  color: white;
}

.booknow a {
  color: white !important;
  text-decoration-line: none;
}
.VCol {
  padding: 0px !important;
}
/* overlay */

/* .overlay {
  position: fixed;
  z-index: 999;
  display: flex;
  overflow: hidden !important;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 55%);
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
}

.overlay-content {
  padding: 20px;
  border-radius: 8px;
  background-color: white;
  inline-size: 85%;
  margin-block-start: 15px !important;
} */
>>> .login-form .v-field {
  height: 35px !important;
  padding: 0 !important;
}

>>> .login-form .v-input__details {
  padding: 0 !important;
  min-height: 0px;
}

>>> .v-messages {
  font-size: 10px;
  min-height: 5px;
}
>>> .login-form .v-field__prepend-inner {
  height: 35px !important;
}
>>> .login-form .v-field__append-inner {
  height: 35px !important;
  padding: 0 !important;
}

>>> .login-form .v-field__input {
  /* align-items: baseline; */
  padding-top: 0 !important;
  height: 35px !important;
  /* top: 8px !important; */
}

>>> .datePick .v-field__input {
  height: -moz-available !important;
  -moz-transform: translateY(-16%) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #a5a4a4 !important;
}

>>> .itemType .v-field__input {
  /* top:8px !important; */
}

/* >>> .login-form .v-autocomplete .v-autocomplete__selection-text {
  position: relative !important;
  top: -9px !important;
} */
/* >>> .v-autocomplete .v-autocomplete__selection-text {
  overflow: hidden;
  text-overflow: ellipsis;
  top: -9px;
  position: relative;
  white-space: nowrap;
  padding-top: 0 !important;
} */

>>> .login-form .v-field__input .input-0-messages {
  top: -1px !important;
}

.but-color {
  background-color: #1f1f45 !important;
  color: white !important;
}
>>> .login-form .v-selection-control--inline .v-label {
  width: auto;
  font-size: 10px;
  font-weight: 650;
  margin-left: 4px;
  color: black;
}
>>> .radio_btn .v-input__details {
  min-height: 0px !important;
  padding-top: 0px !important;
  display: none !important;
}

>>> .v-selection-control {
  --v-selection-control-size: 18px !important;
  align-items: center !important;
}

>>> .v-selection-control__wrapper {
  height: 20px !important;
  width: 20px !important;
}

>>> .v-selection-control__input > .v-icon {
  font-size: 18px !important;
}

.input-form {
  border: 1px solid #9b9898;
  max-width: 100%;
  height: 35px;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  /* top: -1px; */
}
/* @media (min-width: 992px) and (max-width: 1400px) {
  .to_ship_style {
    margin-block-start: -24px;
  }
} */
.v-label {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: black !important;
  position: relative !important;
    top:1px !important;
}
>>> .login-form1 .v-field__input {
  /* top: 8px !important; */
}
>>> .dp__pointer {
  cursor: pointer;
  padding-top: 0px;
  padding-bottom: 0px;
  border-color: gray !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  height: 35px;
}

>>> .dp__menu {
  min-width: auto !important;
}

>>> .dp__instance_calendar {
  position: relative !important;
  width:200px !important;
}

>>> .dp__menu_inner {
  background: white !important;
  border: 1px solid gray !important;
  padding: 1px 4px !important;
}

>>> .dp__btn {
  height: 20px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}

>>> .dp__inner_nav {
  height: 22px !important;
}

>>> .dp__calendar_header_item {
  font-size: 12px !important;
  width: 23px !important;
  height: 23px !important;
}

>>> .dp__cell_inner {
  width: 20px !important;
  height: 20px !important;
}

@media only screen and (max-width: 480px) {
  .measureBox {
    width: 100% !important;
  }
  .btnBox {
    width: 50% !important;
  }
  .unitBox {
    width: 33.33% !important;
    flex-direction: column;
    display: flex;
    margin-top: 2px;
  }
  .unitBox2 {
    width: 33.33% !important;
    flex-direction: column;
    display: flex;
    margin-top: 2px;
  }
  .unitBox3 {
    width: 50% !important;
    flex-direction: column;
    display: flex;
    margin-top: 10px;
  }
  .unitBox4 {
    width: 50% !important;
  }
  .unitBox1 {
    display: none;
  }
}
@media only screen and (min-width: 480px) {
  .unitBox2 {
    display: none;
  }
}

>>>.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
        background: none !important;
}
>>>.postal-form .v-field__input {
    top: -0px !important;
}
>>>.v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--active input {
    transition: none;
    top: 0px;
    height: 30px;
}

>>>.v-field.v-field--variant-underlined .v-field__append-inner{
    align-items: center;
}
</style>
